import angular from 'angular';
import uiRouter from 'angular-ui-router';
import proceduresComponent from './procedures.component';
import dataTable from 'angular-material-data-table';
import FileSaver from 'angular-file-saver';

let proceduresModule = angular.module('procedures', [
    uiRouter,
    dataTable,
    FileSaver
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('procedures', {
        url: '/procedures',
        component: 'procedures',
        parent: 'main',
        data: {
            permissions: {
                only: ['OPERATOR'],
                redirectTo: 'home'
            }
        },
        resolve: {
        }
    });
})
.component('procedures', proceduresComponent)
.name;

export default proceduresModule;
